import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalTemplateGroupLine  {
    _originalTypeClassName = "zERP.BO.GeneralJournalTemplateGroupLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalTemplateGroupLine.translate = translateService;
}
this.Amounts = [];
this.Accounts = [];
this.GeneralJournalTemplateGroupLineKey = null;
this._key = this.GeneralJournalTemplateGroupLineKey = 0; 
}

static translate: TranslateService;
_key: any;
Amounts:any;
Accounts:any;
private _GeneralJournalTemplateGroupLineKey:any;
get GeneralJournalTemplateGroupLineKey(): any {
    return this._GeneralJournalTemplateGroupLineKey;
  }
set GeneralJournalTemplateGroupLineKey(value: any) {
    this._GeneralJournalTemplateGroupLineKey = value;
    this._key = value;
  }
static setAmounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Amounts == null) $this.Amounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Amounts.length > 0) {
                    Domain.GeneralJournalTemplateGroupLine.removeAmounts($this, $this.Amounts[0]);
                }

                Domain.GeneralJournalTemplateGroupLine.addManyAmounts($this, copyItems);
            }
static addManyAmounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalTemplateGroupLine.addAmounts($this, items[i]);
                }
            }
static addAmounts = ($this, item) => {
                if ($this.Amounts == null) $this.Amounts = [];
                if (item == null || $this.Amounts.indexOf(item) > -1) return;
                $this.Amounts.push(item);
}
static addRangeAmounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalTemplateGroupLine.addAmounts($this, item));
            }
static removeAmounts = ($this, item) => {
                if ($this == null || $this.Amounts == null || $this.Amounts.indexOf(item) === -1) return;
                var _index = $this.Amounts.indexOf(item);
                $this.Amounts.splice(_index, 1);
}
static clearAmounts = ($this) => { $this.Amounts = null; }
static setAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Accounts == null) $this.Accounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Accounts.length > 0) {
                    Domain.GeneralJournalTemplateGroupLine.removeAccounts($this, $this.Accounts[0]);
                }

                Domain.GeneralJournalTemplateGroupLine.addManyAccounts($this, copyItems);
            }
static addManyAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalTemplateGroupLine.addAccounts($this, items[i]);
                }
            }
static addAccounts = ($this, item) => {
                if ($this.Accounts == null) $this.Accounts = [];
                if (item == null || $this.Accounts.indexOf(item) > -1) return;
                $this.Accounts.push(item);
}
static addRangeAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalTemplateGroupLine.addAccounts($this, item));
            }
static removeAccounts = ($this, item) => {
                if ($this == null || $this.Accounts == null || $this.Accounts.indexOf(item) === -1) return;
                var _index = $this.Accounts.indexOf(item);
                $this.Accounts.splice(_index, 1);
}
static clearAccounts = ($this) => { $this.Accounts = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalTemplateGroupLineKey == null || $this.GeneralJournalTemplateGroupLineKey == 0;
            }


}